export function normalizeCode(raw: string): string {
  return raw.toUpperCase().replace(/[^A-Z0-9]/g, "");
}

export type ParsedShareQr =
  | { type: "join"; code: string }
  | { type: "pair"; token: string };

/**
 * Erkennt den Inhalt eines gescannten QR-Codes:
 * - Beitritts-Links (…/j/CODE) und nackte Session-Codes („ABC123“ / „ABC-123“)
 * - Pairing-Links (…/pair/TOKEN) eines wartenden Rechners
 */
export function parseShareQr(text: string): ParsedShareQr | null {
  const trimmed = text.trim();

  const pairMatch = trimmed.match(/\/pair\/([A-Za-z0-9_-]+)\/?(?:[?#]|$)/);
  if (pairMatch?.[1]) return { type: "pair", token: pairMatch[1] };

  const joinMatch = trimmed.match(/\/j\/([A-Za-z0-9-]+)\/?(?:[?#]|$)/);
  if (joinMatch?.[1]) {
    const code = normalizeCode(joinMatch[1]);
    if (code.length === 6) return { type: "join", code };
    return null;
  }

  const bare = normalizeCode(trimmed);
  if (bare.length === 6 && !trimmed.includes("/")) {
    return { type: "join", code: bare };
  }
  return null;
}
